import fireplace from "./fireplace.jsx";
import spurt from "./spurt.jsx";

export default {
  fireplace,
  spurt,
};
